/* 商品選択 */
import React, { useEffect } from 'react';
import ProductList from '../templates/ProductList';
import { handleBrowzerBack } from '../BrowzerBack';
import { createRoot } from 'react-dom/client';

const ProductSelect: React.FC = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
  }, []);
  return (
    <>
      <ProductList />
    </>
  );
};
const container = document.getElementById('product-select-applicant');
if (container) {
  const root = createRoot(container);
  root.render(<ProductSelect />);
}
